import React, { useState, useEffect } from 'react';
import { TextField, Button, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import dayjs from 'dayjs';

const PatientSignUp = ({ open, handleClose, handleSubmit, selectedPatient }) => {
    const [newPatient, setNewPatient] = useState({
        dni: '',
        name: '',
        dob: '',
        age: '',
        sex: '',
        maritalStatus: '',
        insurance: '',
        email: '',
        address: '',
        phone: '',
        otherData: `Atopias:\nHTA:\nDM:\nDislipidemia:\nTiroides:\nFumado:\nEtilismo:\n\nG P A C E O\nFUR:\nPlanificacion:\nCirugias:\nVacuna Papiloma:`,
        date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    });

    useEffect(() => {
        if (selectedPatient) {
            setNewPatient(selectedPatient);
        }
    }, [selectedPatient]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedPatient = { ...newPatient, [name]: value };
        
        if (name === 'dob') {
            const birthDate = dayjs(value);
            const today = dayjs();
            const ageInYears = today.diff(birthDate, 'year');
            const ageInMonths = today.diff(birthDate, 'month') % 12;
            const ageInDays = today.diff(birthDate, 'day') % 30;

            if (ageInYears < 1) {
                updatedPatient.age = `${ageInMonths} meses y ${ageInDays} días`;
            } else {
                updatedPatient.age = `${ageInYears} años`;
            }

            updatedPatient.dob = value; // Actualizar la fecha de nacimiento
        }

        setNewPatient(updatedPatient);
    };

    const handleFormSubmit = () => {
        handleSubmit(newPatient);
        handleClose();
        setNewPatient({
            dni: '',
            name: '',
            dob: '',
            age: '',
            sex: '',
            maritalStatus: '',
            insurance: '',
            email: '',
            address: '',
            phone: '',
            otherData: `Atopias:\nHTA:\nDM:\nDislipidemia:\nTiroides:\nFumado:\nEtilismo:\n\nG P A C E O\nFUR:\nPlanificacion:\nCirugias:\nVacuna Papiloma:`,
            date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        });
    };

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{selectedPatient ? 'Modificar Paciente' : 'Agregar Paciente'}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {selectedPatient ? 'Modificar los detalles del paciente.' : 'Ingrese los detalles del nuevo paciente.'}
                </DialogContentText>
                <TextField 
                    autoFocus
                    margin="dense"
                    label="DNI"
                    type="text"
                    fullWidth
                    name="dni"
                    value={newPatient.dni}
                    onChange={handleInputChange}
                />
                <TextField 
                    margin="dense"
                    label="Nombre"
                    type="text"
                    fullWidth
                    name="name"
                    value={newPatient.name}
                    onChange={handleInputChange}
                />
                <TextField 
                    margin="dense"
                    label="Fecha de Nacimiento"
                    type="date"
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                    name="dob"
                    value={newPatient.dob}
                    onChange={handleInputChange}
                />
                <TextField 
                    margin="dense"
                    label="Edad"
                    type="text"
                    fullWidth
                    name="age"
                    value={newPatient.age}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <TextField 
                    margin="dense"
                    label="Sexo"
                    select
                    fullWidth
                    name="sex"
                    value={newPatient.sex}
                    onChange={handleInputChange}
                >
                    <MenuItem value="Masculino">Masculino</MenuItem>
                    <MenuItem value="Femenino">Femenino</MenuItem>
                </TextField>
                <TextField 
                    margin="dense"
                    label="Estado Civil"
                    select
                    fullWidth
                    name="maritalStatus"
                    value={newPatient.maritalStatus}
                    onChange={handleInputChange}
                >
                    <MenuItem value="Soltero">Soltero</MenuItem>
                    <MenuItem value="Casado">Casado</MenuItem>
                    <MenuItem value="Divorciado">Divorciado</MenuItem>
                    <MenuItem value="Union libre">Union libre</MenuItem>
                    <MenuItem value="Viudo">Viudo</MenuItem>
                </TextField>
                <TextField 
                    margin="dense"
                    label="Seguro"
                    type="text"
                    fullWidth
                    name="insurance"
                    value={newPatient.insurance}
                    onChange={handleInputChange}
                />
                <TextField 
                    margin="dense"
                    label="Correo Electrónico"
                    type="email"
                    fullWidth
                    name="email"
                    value={newPatient.email}
                    onChange={handleInputChange}
                />
                <TextField 
                    margin="dense"
                    label="Domicilio"
                    type="text"
                    fullWidth
                    name="address"
                    value={newPatient.address}
                    onChange={handleInputChange}
                />
                <TextField 
                    margin="dense"
                    label="Teléfono"
                    type="text"
                    fullWidth
                    name="phone"
                    value={newPatient.phone}
                    onChange={handleInputChange}
                />
                <TextField 
                    margin="dense"
                    label="Otros Datos"
                    multiline
                    fullWidth
                    rows={6}
                    name="otherData"
                    value={newPatient.otherData}
                    onChange={handleInputChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleFormSubmit} color="primary">
                    {selectedPatient ? 'Modificar' : 'Agregar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PatientSignUp;
